<template>
    <div class="home">
        <services></services>
        <section class="center-link-container" style="display: none">
            <router-link :to="'center'" class="center-link">
                <img src="../../src/assets/1.png">
                <span>СИТУАЦИОННЫЙ ЦЕНТР ЭИОС</span>
            </router-link>
        </section>
    </div>
</template>

<script>
    // @ is an alias to /src
    import Services from "../components/home/Services";


    export default {
        name: 'Home',
        components: {
            Services
        }
    }
</script>

<style scoped>
    .center-link-container{
        height: 429px;
        background-color: #dc7d43;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .center-link{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 360px;
        text-decoration: none;
        box-sizing: border-box;
        padding: 0 25px;
    }

    .center-link img{
        width: 250px;
        margin-bottom: 30px;
    }

    .center-link span{
        font-weight: 600;
        color: rgb(24, 34, 75) !important;
        font-size: 24px;
        font-family: 'PT Sans',Arial,sans-serif;
        text-transform: uppercase;
        line-height: 1.35;
    }



</style>
